import noop from '@gaia/util/noop/action'
import index from './action/index'
import onboarding from './action/onboarding'
import onboardingSuccess from './action/onboardingSuccess'
import access from './action/access'
import validateLogin from './action/validateLogin'
import validateRedirect from './action/validateRedirect'
import logout from './action/logout'
import loginLink from './action/loginLink'
import oauth from './action/oauth'
import external from './action/external'

export default {
  index,
  context: noop,
  access,
  logout,
  loginLink,
  validateLogin,
  validateRedirect,
  onboarding,
  onboardingSuccess,
  oauth,
  external,
}
